<template>
  <v-list dense>
      <v-list-item>
          <v-list-title>
            ID:
            <v-label>
                {{ userProfile.nickname.substring(0, 6) }}...
            </v-label>
        </v-list-title>
      </v-list-item>
      <v-list-item v-if="isUserLoggedIn">   
          <v-list-title @click="copyWalletAddress">
              {{ formattedWalletAddress }}
              <v-icon>mdi-content-copy</v-icon>
          </v-list-title>
      </v-list-item>
    <v-list-item
      v-for="item in menuItems"
      :key="item.route"
      :to="item.route"
      :exact="true"
      router
    >
      <v-list-item>
        <v-list-item-title>{{ $t(`userCenter['${item.title}']`) }}</v-list-item-title>
      </v-list-item>
    </v-list-item>

    <v-list-item>
      <v-menu offset-y>
        <template v-slot:activator="{ props }">
          <v-btn text v-bind="props">
            🌏 {{ selectedLanguageLabel }}
            <v-icon right>mdi-chevron-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-for="lang in languages" :key="lang.code" @click="changeLanguage(lang.code, lang.label)">
            <v-list-item-title>{{ lang.label }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
  </v-list-item>
  <v-list-item>
      <v-list-title @click="toogleWalletConection">
        {{ isUserLoggedIn ? formattedWalletAddress : $t('siteHeader.connectWallet') }} 
        <v-icon>mdi-logout</v-icon>
      </v-list-title>
  </v-list-item>
  </v-list>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: 'UserSidebar',
  data() {
    return {
      menuItems: [
        { title: "dashboard", route: '/dashboard' },
        { title: "profile", route: '/dashboard/profile' },
        { title: "orders", route: '/dashboard/order' },
        { title: "address", route: '/dashboard/address' },
        { title: "earnings", route: '/dashboard/earnings' },
        { title: "invites", route: '/dashboard/invites' },
      ],
      languages: [
        { code: 'zhHant', label: '繁體' },
        { code: 'en', label: 'English' },
        { code: 'ko', label: '한국어' },
      ],
      selectedLanguageLabel: '繁體',
    };
  },
  mounted() {
    if(!this.isUserLoggedIn) {
      this.$router.back();
    }
    this.changeLanguage(this.$i18n.locale, this.selectedLanguageLabel);
  },
  computed: {
    ...mapState({
      isUserLoggedIn: state => state.isUserLoggedIn || false,
      userProfile: state => state.userProfile || {},
      walletAddress: state => state.walletAddress || ''
    }),
    formattedWalletAddress() {
      if (!this.walletAddress) return '';
      return `${this.walletAddress.slice(0, 6)}.....${this.walletAddress.slice(-6)}`;
    },
  },
  methods: {
    changeLanguage(lang, label) {
      this.selectedLanguageLabel = label;
      this.$i18n.locale = lang;
      localStorage.setItem('language', lang);
      localStorage.setItem('languageLabel', label);
    },
    copyWalletAddress() {
      navigator.clipboard.writeText(this.walletAddress).then(() => {
        this.$toast.success('Copied to clipboard');
      }).catch((error) => {
        this.$toast.error('Failed to copy to clipboard'+ error.message);
      });
    },
    toogleWalletConection() {
      this.$emit('toogle-wallet-connection');
      console.log('toogleWalletConection');
    }
  }
};
</script>

<style scoped>
</style>
